<template>
  <layout-report-step
    :md="md"
    :isDone="isDone"
    :title="header.title"
    :description="header.description"
    :debug="[numberplate, user, contact]"
  >
    <v-card flat max-width="500" class="pt-4 pl-4 pr-4">
      <v-form ref="form" v-model="valid">
        <v-subheader>{{ $t("report.formPersonalData.numberplateForm") }}</v-subheader>
        <numberplate-form
          v-model="numberplate"
          :valid="valid"
          v-on:valid="setValid"
          :countryCode="countryCode"
        ></numberplate-form>

        <v-subheader>{{ $t("report.formPersonalData.subtitle") }}</v-subheader>
        <v-text-field
          :value="user.firstName"
          @blur="updateUserFirstName"
          :label="$t('report.formPersonalData.firstName')"
          :rules="noNumberRule"
          required
          outlined
          data-test-form-firstName
        ></v-text-field>
        <v-text-field
          :value="user.lastName"
          @blur="updateUserLastName"
          :label="$t('report.formPersonalData.lastName')"
          :rules="noNumberRule"
          required
          outlined
          data-test-form-lastName
        >
        </v-text-field>
        <v-text-field
          :label="$t('report.formPersonalData.mail')"
          :value="contact.email"
          @blur="updateUserEmail"
          type="email"
          :rules="emailRules"
          autocomplete="email"
          required
          outlined
          data-test-form-mail
        ></v-text-field>

        <v-text-field
          :label="$t('report.formPersonalData.phone')"
          :value="contact.phone"
          @blur="updateUserPhone"
          type="tel"
          :rules="phoneNumberRules"
          required
          outlined
          data-test-form-phone
        ></v-text-field>
      </v-form>
    </v-card>
  </layout-report-step>
</template>

<script lang="ts">
import NumberplateForm from "@/components/utility/NumberplateForm.vue";
import LayoutReportStep from "@/layouts/LayoutReportStep.vue";
import { CountryCodeEnum } from "@/lib/enum/country-code.enum";
import { IReportHeaderData } from "@/lib/interfaces/Report/IReportHeaderData";
import { IReportStep } from "@/lib/interfaces/Report/IViewReportStep";
import { emailRule, noNumberRule, phoneRule } from "@/lib/rules/contactRule.ts";
import { requiredRule } from "@/lib/rules/requiredRule.ts";
import { parsePhone } from "@/lib/utility/parsePhone";
import ReportStepMixin from "@/mixins/ReportStepMixin.vue";
import { ReportScreenEnum } from "@/store/enum/partner/report-screen.enum";
import { ReportModule } from "@/store/modules/report.store";
import { Component } from "vue-property-decorator";

@Component({
  components: {
    LayoutReportStep,
    NumberplateForm
  }
})
export default class ReportPersonalDataSimple extends ReportStepMixin implements IReportStep {
  public md = 4;
  public static screenName = ReportScreenEnum.contactdetails;
  public header: IReportHeaderData = {
    title: "report.formPersonalData.title",
    description: "report.formPersonalData.description"
  };

  screen = ReportScreenEnum.simplecontact;

  phone: any;

  valid = false;

  numberplateValid = false;

  setValid(value: boolean) {
    this.numberplateValid = value;
  }

  get isDone() {
    return this.valid && this.numberplateValid;
  }

  get noNumberRule() {
    const rules = [];

    rules.push(requiredRule());
    rules.push(noNumberRule());

    return rules;
  }

  get emailRules() {
    const rules = [];

    rules.push(requiredRule());
    rules.push(emailRule());

    return rules;
  }

  get phoneNumberRules() {
    const rules = [];

    rules.push(requiredRule());
    rules.push(phoneRule());

    return rules;
  }

  get numberplate(): string {
    return ReportModule.numberplate;
  }

  set numberplate(value: string) {
    ReportModule.setNumberplate(value);
  }

  get user(): any {
    return ReportModule.user;
  }

  get contact(): any {
    return ReportModule.contact;
  }

  get countryCode(): CountryCodeEnum {
    return ReportModule.partnerCountryCode;
  }

  updateUserFirstName(e: any) {
    ReportModule.setUser({ firstName: e.target.value });
  }
  updateUserLastName(e: any) {
    ReportModule.setUser({ lastName: e.target.value });
  }
  updateUserEmail(e: any) {
    ReportModule.setContact({ email: e.target.value });
  }
  updateUserPhone(e: any) {
    ReportModule.setContact({ phone: parsePhone(e.target.value, ReportModule.partner.countryCode as CountryCodeEnum) });
  }
}
</script>

<style></style>
